import React from 'react'
import { SettingRow } from '../setting-row/setting-row';
import { Input } from '@shared/ui/input/input';
import s from './full-name-setting.module.scss'
import { profileValidations } from '@utils/lib/validations';

export const FullNameSetting = ({ requireFname = false }) => {
	const fnameValidation = {
		...profileValidations.fname,
		...(requireFname
			? { required: { value: true, message: "Заполните поле" } }
			: {}),
	};

	return (
		<SettingRow title={'ФИО'}>
			<Input
					placeholder="Иван"
					name="name"
					label={"Имя"}
					required
					className={s.input}
					validation={profileValidations.name}
				/>
				<Input
					placeholder="Иванов"
					name="fname"
					label={"Фамилия"}
					required={requireFname}
					className={s.input}
					validation={fnameValidation}
				/>
				<Input
					placeholder="Иванович"
					name="lname"
					label={"Отчество"}
					className={s.input}
					validation={profileValidations.lname}
				/>
		</SettingRow>
	)
}
